import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import ProjectDetails from "@/views/projects/ProjectDetails.vue";
import PhasePage from "@/views/projects/PhasePage.vue";
import { useUserStore } from "@/stores/user";
import TerminPage from "@/views/projects/TerminPage.vue";
import ExampleArchiveView from "@/views/example-archive/ExampleArchiveView.vue";
import MonthlyBonusView from "@/views/installer/MonthlyBonusView.vue";
import InstallersView from "@/views/installer/InstallersView.vue";
import InstallerProfileView from "@/views/installer/InstallerProfileView.vue";
import BonusReportDetails from "@/views/installer/BonusReportDetails.vue";
import LoginView from "@/views/auth/LoginView.vue";
import PublicReviewView from "@/views/PublicReviewView.vue";
import ReviewsView from "@/views/marketing/ReviewsView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/projects/:id",
    name: "Projects",
    component: ProjectDetails,
  },
  {
    path: "/projects/:id/phase/:phaseId",
    name: "Phase",
    component: PhasePage,
    props: true,
  },
  {
    path: "/projects/:id/termin/:terminId",
    name: "Termin",
    component: TerminPage,
    props: true,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
  },
  {
    path: "/review/:token",
    name: "Review",
    component: PublicReviewView,
    meta: { public: true },
  },
  {
    path: "/build",
    name: "Build",
    component: ExampleArchiveView,
  },
  {
    path: "/marketing/reviews",
    name: "Marketing Reviews",
    component: ReviewsView,
  },
  {
    path: "/installers/monthly-bonus",
    name: "Monthly Bonus",
    component: MonthlyBonusView,
  },
  {
    path: "/installers",
    name: "Installers",
    component: InstallersView,
  },
  {
    path: "/installers/:id",
    name: "Installer profile",
    component: InstallerProfileView,
  },
  {
    path: "/installers/:id/report/:reportId",
    name: "Bonus report details",
    component: BonusReportDetails,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const userStore = useUserStore();

  if (to.meta.public) {
    next();
    return;
  }

  if (!userStore.accessToken && to.name !== "Login") {
    next({ name: "Login", query: { redirect: to.fullPath } });
  } else {
    if (userStore.accessToken && to.name === "Login") {
      next({ name: "Home" });
    }
  }
  next();
});

export default router;
